var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercolationTank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.672 21.5684C42.672 27.9745 41.0761 32.2829 34.8082 38.0401C34.691 38.1495 21.4981 49.3753 21.4981 49.3753C21.4981 49.3753 8.24998 37.9592 8.13263 37.8498C3.33964 33.6351 0.332031 27.9745 0.332031 21.5684C0.332031 9.87469 9.81216 0.402344 21.4981 0.402344C33.1918 0.402344 42.672 9.87469 42.672 21.5684Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4728 38.2527C30.7732 38.2527 38.3127 30.7132 38.3127 21.4127C38.3127 12.1123 30.7732 4.57275 21.4728 4.57275C12.1723 4.57275 4.63281 12.1123 4.63281 21.4127C4.63281 30.7132 12.1723 38.2527 21.4728 38.2527Z",
    fill: "#FFCE55",
    stroke: "#FFAA00",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4722 34.9454C28.7813 34.9454 34.7063 29.0203 34.7063 21.7114H8.23828C8.23828 29.0203 14.1633 34.9454 21.4722 34.9454Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercolationTank);
export default __webpack_public_path__ + "static/media/percolation-tank.842755bfef69950ac0debdb53b35f17a.svg";
export { ForwardRef as ReactComponent };